import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppOnlinePaymentAdyenComponent } from './app-online-payment/app-online-payment-adyen/app-online-payment-adyen.component';
import { AppOnlinePaymentFailedComponent } from './app-online-payment/app-online-payment-failed/app-online-payment-failed.component';
import { AppOnlinePaymentSuccessComponent } from './app-online-payment/app-online-payment-success/app-online-payment-success.component';
import { HomeComponent } from './home/home.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { TermsConditionPageComponent } from './terms-condition-page/terms-condition-page.component';
import { HomepageArabicComponent } from './homepage-arabic/homepage-arabic.component';
import { AppOnlinePaymentSuccessArabicComponent } from './app-online-payment/app-online-payment-success-arabic/app-online-payment-success-arabic.component';
import { AppOnlinePaymentFailedArabicComponent } from './app-online-payment/app-online-payment-failed-arabic/app-online-payment-failed-arabic.component';


const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home'
  },
  {
    path: "home",
    component: HomeComponent,
  },
  {
    path: "home-ar",
    component: HomepageArabicComponent,
  },
  {
    path: "app-online-payment-adyen",
    component: AppOnlinePaymentAdyenComponent,
  },
  {
    path: "app-online-payment-success",
    component: AppOnlinePaymentSuccessComponent,
  },
  {
    path: "app-online-payment-success-arabic",
    component: AppOnlinePaymentSuccessArabicComponent,
  },
  {
    path: "app-online-payment-failed",
    component: AppOnlinePaymentFailedComponent,
  },
  {
    path: "app-online-payment-failed-arabic",
    component: AppOnlinePaymentFailedArabicComponent,
  },
  {
    path: "terms-condition",
    component: TermsConditionComponent,
  },
  {
    path: "terms-and-condition",
    component: TermsConditionPageComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
